/*
 * @license
 * Copyright© Celligence International, LLC - 2025
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useEffect, useState, Suspense, lazy, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SpinnerLoader from "../SpinnerLoader";
import { isMobileDevice, isMobileNotTabletDevice } from "../Utils";

const Preview = lazy(() => import("./Preview"));
const Authenticate = lazy(() => import("./Authenticate"));

export default function WebsitePreview() {
    const { key } = useParams();
    const [userAuthenticated, setUserAuthenticated] = useState(false);
    const [isMobile, setIsMobile] = useState(isMobileDevice());
    const [isMobileNotTablet, setIsMobileNotTablet] = useState(isMobileNotTabletDevice());
    

    useEffect(() => {
        function handleResize() {
            setIsMobile(isMobileDevice());
            setIsMobileNotTablet(isMobileNotTabletDevice());
        }

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <Container fluid className={userAuthenticated ? "ps-0 pe-0" : "ps-0 pe-0 overflow-hidden"}>
            <Suspense fallback={<SpinnerLoader />}>
                <Row>
                    <Col sm={12}>
                        {userAuthenticated ? (
                            <Preview
                                previewKey={key}
                                isMobile={isMobile}
                                isMobileNotTablet={isMobileNotTablet}
                            />
                        ):(
                            <Authenticate
                                previewKey={key}
                                isMobile={isMobile}
                                setUserAuthenticated={setUserAuthenticated}
                            />
                        )}
                    </Col>
                </Row>
            </Suspense>
        </Container>
    );
};